document.addEventListener('DOMContentLoaded', function() {

  // ── NTH Sidebar: plain sub-panel slide-in/out ──────────────────────────────
  (function initNthSubPanels() {
    function openNthPanel(panelId) {
      const panel = document.getElementById(panelId);
      if (!panel || !panel.classList.contains('nth-sidebar__sub-panel')) return;

      panel.removeAttribute('inert');
      panel.classList.add('is-open');

      const sidebar = document.getElementById('sidebar-menu');
      sidebar?.classList.add('has-sub-open');
    }

    function closeNthPanel(panel) {
      if (!panel) return;

      panel.classList.remove('is-open');

      // Restore inert after the slide-out transition ends
      panel.addEventListener('transitionend', function handler() {
        panel.setAttribute('inert', '');
        panel.removeEventListener('transitionend', handler);

        // Remove has-sub-open once no sub-panels remain open
        const sidebar = document.getElementById('sidebar-menu');
        if (sidebar && !sidebar.querySelector('.nth-sidebar__sub-panel.is-open')) {
          sidebar.classList.remove('has-sub-open');
        }
      });

      // Reset the trigger button's aria-expanded
      const sidebar = document.getElementById('sidebar-menu');
      sidebar?.querySelector(`[aria-controls="${panel.id}"]`)?.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function(e) {
      // Open on chevron button click
      const triggerBtn = e.target.closest('.nth-sidebar__nav-link--has-sub[aria-controls]');
      if (triggerBtn) {
        triggerBtn.setAttribute('aria-expanded', 'true');
        openNthPanel(triggerBtn.getAttribute('aria-controls'));
        return;
      }

      // Close on Back button click
      const backBtn = e.target.closest('[data-nth-back]');
      if (backBtn) {
        closeNthPanel(backBtn.closest('.nth-sidebar__sub-panel'));
      }
    });

    // Reset all sub-panels when the drawer itself closes.
    // dialog:after-hide does NOT bubble, so we must attach directly to the element.
    const sidebarEl = document.getElementById('sidebar-menu');
    if (sidebarEl) {
      sidebarEl.addEventListener('dialog:after-hide', function() {
        sidebarEl.querySelectorAll('.nth-sidebar__sub-panel.is-open').forEach(function(p) {
          p.classList.remove('is-open');
          p.setAttribute('inert', '');
        });

        sidebarEl.classList.remove('has-sub-open');

        sidebarEl.querySelectorAll('.nth-sidebar__nav-link--has-sub[aria-expanded="true"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    }
  })();

  // ── NTH Mega menu: smooth accordion expand/collapse ───────────────────────
  (function initNthMegaAccordions() {
    document.addEventListener('click', function(e) {
      const summary = e.target.closest('.nth-mmm__accordion-toggle');
      if (!summary) return;
      const details = summary.closest('.nth-mmm__accordion');
      if (!details) return;

      e.preventDefault();

      if (details.open) {
        // Animate closed before removing the open attribute
        const body = details.querySelector('.nth-mmm__accordion-body');
        details.classList.add('is-closing');
        if (body) {
          body.addEventListener('transitionend', function handler() {
            body.removeEventListener('transitionend', handler);
            details.removeAttribute('open');
            details.classList.remove('is-closing');
          }, { once: true });
        } else {
          details.removeAttribute('open');
          details.classList.remove('is-closing');
        }
      } else {
        details.setAttribute('open', '');
      }
    });
  })();
  
  // Get the 'filter.p.m.custom.make_model_year' parameter from the current URL
  const current_url = new URL(window.location);
  const current_mmy_car = current_url.searchParams.get('filter.p.m.custom.make_model_year');
  
  // Function to set the URL parameter
  const setUrlParam = (link) => {
    const linkUrl = new URL(link.getAttribute('href'), window.location);
    linkUrl.searchParams.set('filter.p.m.custom.make_model_year', current_mmy_car);
    link.setAttribute('href', linkUrl.toString());
  };
  
  // Select all links inside the mega menu
  const menuLinks = document.querySelectorAll('.mega-menu ul li:first-child ul li a');
  
  // Update links in mega menu
  if (menuLinks.length > 0 && current_mmy_car !== null) {
    menuLinks.forEach(link => {
      setUrlParam(link);
    });
  }

  // Related products timer variables
  let relatedProductsElapsed = 0;
  const relatedProductsIntervalTime = 100;
  const relatedProductsMaxTime = 5000;
  
  // Function to check for related product links
  const relatedProductsCheckForElements = () => {
    // Select all links inside related products
    const relatedProductsLinks = document.querySelectorAll('.shopify-section--related-products .product-card__media');
  
    // If elements are found or max time has elapsed
    if (relatedProductsLinks.length > 0 || relatedProductsElapsed >= relatedProductsMaxTime) {
      clearInterval(relatedProductsIntervalId); // Stop checking
      console.log("Stop");
  
      if (relatedProductsLinks.length > 0 && current_mmy_car !== null) {
        relatedProductsLinks.forEach(link => {
          setUrlParam(link);
        });
      }
    }
  
    relatedProductsElapsed += relatedProductsIntervalTime; // Increase elapsed time
  };
  
  // Check every 100ms, but stop after 5 seconds
  const relatedProductsIntervalId = setInterval(relatedProductsCheckForElements, relatedProductsIntervalTime);

  

  const readMoreLink = document.querySelector('.read-more-link');
  const readMoreContent = document.querySelector('.read-more-content');

  function slideToggle(element, duration = 400) {
    // If the element is hidden, display it and get its full height
    if (element.classList.contains('is-hidden')) {
      element.style.display = 'block';
      element.style.height = 'auto';
      var fullHeight = element.clientHeight;
      element.style.height = '0';
    }

    element.style.overflowY = 'hidden';
    let startHeight = element.classList.contains('is-hidden') ? 0 : element.clientHeight;
    let endHeight = element.classList.contains('is-hidden') ? fullHeight : 0;

    element.style.height = `${startHeight}px`;

    // Force a redraw to let the browser acknowledge the height change
    element.getBoundingClientRect();

    // Animate over duration
    element.style.transitionProperty = 'height';
    element.style.transitionDuration = `${duration}ms`;
    element.style.height = `${endHeight}px`;

    // Toggle class
    element.classList.toggle('is-hidden');
    element.classList.toggle('is-visible');

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow-y');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');

      if (element.classList.contains('is-hidden')) {
        element.style.display = 'none'; // Hide the element
      }
    }, duration);
  }

  if (readMoreLink && readMoreContent) {
    if (readMoreContent.classList.contains('is-hidden')) {
      readMoreContent.style.display = 'none';
    }

    readMoreLink.addEventListener('click', function() {
      slideToggle(readMoreContent);
      readMoreLink.textContent = readMoreContent.classList.contains('is-hidden') ? 'Read More' : 'Read Less';
    });
  }  

  const moveDiscountyPortal = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    const cartDrawerFooter = cartDrawer.querySelector('.cart-drawer__footer');
    const totalAndPaymentWrapper = cartDrawer.querySelector('.total-and-payment-wrapper');
    const discountyPortal = cartDrawerFooter?.querySelector('.discounty-portal');

    if (!cartDrawerFooter || !totalAndPaymentWrapper || !discountyPortal) return;
    if (totalAndPaymentWrapper.contains(discountyPortal)) return;

    const buttonGroup = totalAndPaymentWrapper.querySelector('.button-group');

    if (buttonGroup) {
      totalAndPaymentWrapper.insertBefore(discountyPortal, buttonGroup);
      return;
    }

    totalAndPaymentWrapper.appendChild(discountyPortal);
  };

  const updateDiscountyTotalLabel = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    const totalLabel = cartDrawer.querySelector('.discounty-cart-widget__total-label');
    if (!totalLabel) return;

    const targetHtml = 'You saved <span>(sale items)</span>';
    if (totalLabel.innerHTML !== targetHtml) {
      totalLabel.innerHTML = targetHtml;
    }
  };

  const clearDiscountySavingRowInlineStyles = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    const savingRows = cartDrawer.querySelectorAll('.discounty-cart-widget__saving-row');
    if (!savingRows.length) return;

    savingRows.forEach((savingRow) => {
      savingRow.removeAttribute('style');
    });
  };

  moveDiscountyPortal();
  updateDiscountyTotalLabel();
  clearDiscountySavingRowInlineStyles();

  const cartDrawerObserver = new MutationObserver(() => {
    moveDiscountyPortal();
    updateDiscountyTotalLabel();
    clearDiscountySavingRowInlineStyles();
  });

  cartDrawerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('submit', async function(event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || form.dataset.ajaxAtcForm !== 'true') {
      return;
    }

    event.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');

    if (!submitButton || submitButton.dataset.isAdding === 'true') {
      return;
    }

    const defaultText = submitButton.dataset.defaultText || 'Add to Cart';
    const addingText = submitButton.dataset.addingText || 'Adding...';
    const addedText = submitButton.dataset.addedText || 'Added';

    submitButton.dataset.isAdding = 'true';
    submitButton.disabled = true;
    submitButton.textContent = addingText;

    try {
      const formData = new FormData(form);
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!addResponse.ok) {
        throw new Error('Add to cart request failed');
      }

      submitButton.textContent = addedText;

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }

      setTimeout(() => {
        submitButton.textContent = defaultText;
        submitButton.disabled = false;
        delete submitButton.dataset.isAdding;
      }, 3000);
    } catch (error) {
      submitButton.textContent = defaultText;
      submitButton.disabled = false;
      delete submitButton.dataset.isAdding;
      console.error('Product card AJAX add-to-cart error:', error);
    }
  });
});